import {
  AlertTriangle,
  ArrowDownToLine,
  ArrowRightLeft,
  ArrowUpFromLine,
  CheckCircle2,
  Clock,
  Edit,
  Package,
  Plus,
  Settings,
  TimerReset,
  Truck,
  UserPlus,
  Wrench,
  XCircle,
} from 'lucide-react'

export const actionIconMap: Record<string, typeof Clock> = {
  TransferRequested: ArrowRightLeft,
  TransferApproved: CheckCircle2,
  TransferRejected: XCircle,
  TransferScheduled: Clock,
  TransferDelivering: Truck,
  TransferAwaitingReceive: Package,
  TransferPickupReady: Package,
  TransferCompleted: CheckCircle2,
  RepairOpened: Wrench,
  RepairAssigned: UserPlus,
  RepairAcknowledged: CheckCircle2,
  RepairInProgress: Settings,
  RepairWaitingParts: TimerReset,
  RepairCompleted: CheckCircle2,
  RepairClosed: XCircle,
  ItemCheckedOut: ArrowUpFromLine,
  ItemCheckedIn: ArrowDownToLine,
  ItemCreated: Plus,
  ItemUpdated: Edit,
  ItemStatusChanged: AlertTriangle,
}

export const actionColorMap: Record<string, string> = {
  TransferRequested: 'text-info',
  TransferApproved: 'text-success',
  TransferRejected: 'text-destructive',
  TransferScheduled: 'text-info',
  TransferDelivering: 'text-primary',
  TransferAwaitingReceive: 'text-warning',
  TransferPickupReady: 'text-primary',
  TransferCompleted: 'text-success',
  RepairOpened: 'text-warning',
  RepairAssigned: 'text-info',
  RepairAcknowledged: 'text-info',
  RepairInProgress: 'text-primary',
  RepairWaitingParts: 'text-warning',
  RepairCompleted: 'text-success',
  RepairClosed: 'text-muted-foreground',
  ItemCheckedOut: 'text-info',
  ItemCheckedIn: 'text-success',
  ItemCreated: 'text-primary',
  ItemUpdated: 'text-primary',
  ItemStatusChanged: 'text-warning',
}
